import { Select, ConfigProvider } from "antd";
import images from "../../assets";
import "./styles.css";

const EditProfileDropdown = (props) => {
  return (
    <div className="edit-profile-input mobile">
      <ConfigProvider
        theme={{
          components: {
            Select: {
              activeBorderColor: "transparent",
              activeOutlineColor: "transparent",
              hoverBorderColor: "transparent",
              colorBorder: "transparent",
              colorBorderDisabled: "transaprent",
              colorBgBase: "transaprent",
              colorBgContainerDisabled: "transparent",
            },
          },
        }}
      >
        <Select
          {...props}
          suffixIcon={<img src={images.dropdownIcon} alt="dropdown" />}
          showSearch
          placeholder={props?.placeholder || "Please select"}
          className="edit-profile-select"
        >
          {props?.data?.map((item, index) => {
            if (props?.list === "stateProvince") {
              if (!item?.name?.includes("Division")) {
                return (
                  <Select.Option
                    key={index}
                    value={item.name?.replace("District", "")}
                  >
                    {item.name?.replace("District", "")}
                  </Select.Option>
                );
              }
            } else if (props?.list === "country") {
              return (
                <Select.Option key={item.isoCode} value={JSON.stringify(item)}>
                  {item.name}
                </Select.Option>
              );
            } else {
              return (
                <Select.Option key={index} value={item.value}>
                  {item.label}
                </Select.Option>
              );
            }
          })}
        </Select>
      </ConfigProvider>
    </div>
  );
};

export default EditProfileDropdown;
